// Import Dependencies
import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import PropTypes from 'prop-types';

// Import Stylesheet
import styles from './modalBlocker.css';

@inject('modalStore')
@observer
class ModalBlocker extends Component {
    closeModal() {
        // if modal is able to be closed
        if (this.props.modalStore.isModalClosable) {
            // close modal and blocker
            this.props.modalStore.setModalOptions({ isModalOpen: false });
        }
    }

    render() {
        // is the modal transparent or semi-opaque
        const { transparent } = this.props;
        // boolean denoting if modal is supposed to be shown
        const { isModalOpen } = this.props.modalStore;
        // show blocker is modal is open
        if (isModalOpen) {
            return (
                <div className={`${styles.blocker} ${transparent ? styles.transparent : ''}`} onClick={() => this.closeModal()}></div>
            );
        }
        // otherwise hide blocker
        return null;
    }

    static propTypes = {
        transparent: PropTypes.bool
    };
}

export default ModalBlocker;
